// This is used to define the size of sidebar rectangular plugins
export const pluginSizeRectangle = {
    width: 46,
    height: 46
};
// This is used to define the size of circled sidebar plugins
export const pluginSizeCircle = {
    width: 46,
    height: 46
};
